import { inject, Injector, NgModule, provideAppInitializer } from '@angular/core';
import { NavigationSourceService } from '@shared/v2';
import { SentryBrowserModule } from './sentry';
import { InactivityService } from './services/inactivity.service';

export function initInactivityServiceFactory(injector: Injector): () => void {
  return () => {
    const inactivityService = injector.get(InactivityService);

    inactivityService.init();
  };
}

export function navigationSourceServiceFactory(injector: Injector): () => void {
  return () => {
    const navigationSourceService = injector.get(NavigationSourceService);

    navigationSourceService.init();
  };
}

@NgModule({
  imports: [SentryBrowserModule],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = initInactivityServiceFactory(inject(Injector));

      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = navigationSourceServiceFactory(inject(Injector));

      return initializerFn();
    }),
  ],
})
export class CoreFeatureBrowserModule {}
